"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reachedMinimumOptionRequirements = exports.getInitiallySelectedOptionItems = exports.validateBasketItems = exports.validateBasketItemUpdate = exports.validateBasketItemsDelete = exports.isBasketItemStillActive = void 0;
const types_shared_1 = require("../types.shared");
const isBasketItemStillActive = ({ item, options }, deliveryDate) => {
    var _a;
    const deliveryDateIsAfterActivePeriodStart = deliveryDate && item && item.activeFrom
        ? new Date(item.activeFrom).getTime() < deliveryDate.getTime()
        : true;
    const deliveryDateIsBeforeActivePeriodEnd = deliveryDate && item && item.activeTo
        ? new Date(item.activeTo).getTime() > deliveryDate.getTime()
        : true;
    return Boolean(item &&
        ((_a = item.variations) === null || _a === void 0 ? void 0 : _a.length) &&
        item.isActive &&
        item.variations[0].isActive &&
        deliveryDateIsAfterActivePeriodStart &&
        deliveryDateIsBeforeActivePeriodEnd &&
        options.every((option) => option.item && option.item.isActive));
};
exports.isBasketItemStillActive = isBasketItemStillActive;
const validateBasketItemsDelete = (items, deliveryDate) => {
    const validBasketItems = items.filter((i) => (0, exports.isBasketItemStillActive)(i, deliveryDate));
    const invalidBasketItems = items.filter((item) => !validBasketItems.includes(item));
    return { validBasketItems, invalidBasketItems, allItemsValid: invalidBasketItems.length === 0 };
};
exports.validateBasketItemsDelete = validateBasketItemsDelete;
const validateBasketItemUpdate = ({ item, acknowledgedAt, options, }) => item &&
    item.updatedAt &&
    acknowledgedAt &&
    (item.updatedAt > acknowledgedAt ||
        (options === null || options === void 0 ? void 0 : options.some((option) => option.item && option.item.updatedAt && option.item.updatedAt > acknowledgedAt)));
exports.validateBasketItemUpdate = validateBasketItemUpdate;
const validateBasketItems = (items, deliveryDate) => {
    const { allItemsValid, validBasketItems } = (0, exports.validateBasketItemsDelete)(items, deliveryDate);
    const itemsHaveBeenUpdated = validBasketItems.some((item) => (0, exports.validateBasketItemUpdate)(item));
    if (!(allItemsValid && !itemsHaveBeenUpdated)) {
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_BASKET_ITEMS' }),
        };
    }
    return {
        result: (0, types_shared_1.ok)(),
    };
};
exports.validateBasketItems = validateBasketItems;
const getInitiallySelectedOptionItems = (menuItem, basketItem) => new Map((menuItem.options || [])
    .filter(types_shared_1.isNotNil)
    .filter((category) => category._id)
    .map((category) => [
    category._id,
    new Map(basketItem === null || basketItem === void 0 ? void 0 : basketItem.options.filter((0, types_shared_1.areFieldsNotNil)(['category', 'optionItem'])).filter((o) => (category === null || category === void 0 ? void 0 : category._id) === o.category._id).map((basketOption) => {
        var _a;
        return ({
            ...basketOption,
            item: (_a = category === null || category === void 0 ? void 0 : category.items) === null || _a === void 0 ? void 0 : _a.find((i) => (i === null || i === void 0 ? void 0 : i._id) === basketOption.optionItem._id),
        });
    }).filter((0, types_shared_1.areFieldsNotNil)(['item'])).map(({ item, qty }) => [
        item._id,
        { option: category, item, quantity: qty },
    ])),
]));
exports.getInitiallySelectedOptionItems = getInitiallySelectedOptionItems;
const reachedMinimumOptionRequirements = ({ topQuantity, menuItem, selectedOptions, }) => {
    var _a;
    const selectedOptionGroupIds = Array.from(selectedOptions.keys());
    const requiredOptions = (_a = menuItem.options) === null || _a === void 0 ? void 0 : _a.filter((option) => option && (option.minQty || option.qtyPerPerson));
    const selectedOptionGroups = selectedOptionGroupIds.filter((optionGroupId) => {
        var _a;
        const selectedOptionGroup = (_a = menuItem.options) === null || _a === void 0 ? void 0 : _a.find((option) => (option === null || option === void 0 ? void 0 : option._id) === optionGroupId);
        const minimumQty = selectedOptionGroup === null || selectedOptionGroup === void 0 ? void 0 : selectedOptionGroup.minQty;
        const quantityPerPerson = selectedOptionGroup === null || selectedOptionGroup === void 0 ? void 0 : selectedOptionGroup.qtyPerPerson;
        const maximumQty = selectedOptionGroup === null || selectedOptionGroup === void 0 ? void 0 : selectedOptionGroup.maxQty;
        const optionType = selectedOptionGroup === null || selectedOptionGroup === void 0 ? void 0 : selectedOptionGroup.optionType;
        const optionGroup = selectedOptions.get(optionGroupId);
        if (optionGroup) {
            const itemQuantities = Array.from(optionGroup.values()).map(({ quantity }) => quantity || 0);
            const totalNumberOfItems = itemQuantities.reduce((total, itemQty) => total + itemQty, 0);
            if (optionType === 'numbers') {
                if (quantityPerPerson) {
                    return totalNumberOfItems === topQuantity * quantityPerPerson;
                }
                if (maximumQty && minimumQty) {
                    return optionGroup.size >= minimumQty && optionGroup.size <= maximumQty && totalNumberOfItems === topQuantity;
                }
                if (maximumQty) {
                    return optionGroup.size <= maximumQty && totalNumberOfItems === topQuantity;
                }
                if (minimumQty) {
                    return optionGroup.size >= minimumQty && totalNumberOfItems === topQuantity;
                }
            }
            if (optionType === 'ticks') {
                if (minimumQty) {
                    return optionGroup.size >= minimumQty;
                }
            }
        }
        return false;
    });
    return (requiredOptions === null || requiredOptions === void 0 ? void 0 : requiredOptions.length) ? selectedOptionGroups.length >= requiredOptions.length : true;
};
exports.reachedMinimumOptionRequirements = reachedMinimumOptionRequirements;
